import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`

const Dot = styled.div`
    width: 32px;
    height: 32px;
    background-color: #d8d8d8;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    &.active {
        background-image: linear-gradient(to top right, #6c5af0, #88b3ff);
    }
`
const Line = styled.div`
    width: 90px;
    height: 2px;
    background: rgba(151,151,151, 0.5);
    opacity: 0.5;
    &.active {
        background-image: linear-gradient(269deg, #88b3ff 101%, #6c5af0 -23%);
    }
`

export { Wrapper, Dot, Line }